import { Base, Collection } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { AccountEmailPreferenceResource } from './AccountEmailPreference';

/**
 * Relationship classes
 */
export class EmailTypeAttributes {
  id: string = null;
  active: boolean = null;
  description: string = null;
  mailerType: string = null;
  name: string = null;
  visible: boolean = null;
}

export class EmailTypeBelongsTo {}

export class EmailTypeHasOne {}

export class EmailTypeHasMany {
  accountEmailPreferences: () => Collection<AccountEmailPreferenceResource> = () =>
    new Collection<AccountEmailPreferenceResource>();
}

/**
 * Utility interfaces
 */
export interface EmailTypeMethods {}

export interface EmailTypeInterface
  extends EmailTypeAttributes,
    EmailTypeBelongsTo,
    EmailTypeHasOne,
    EmailTypeHasMany,
    EmailTypeType {}

type EmailTypeType = GConstructor<EmailTypeInterface>;

export interface EmailTypeResource
  extends Base<EmailTypeAttributes>,
    EmailTypeInterface,
    EmailTypeMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<EmailTypeAttributes>({
    queryName: 'email_types',
    className: 'EmailType',
    AttributesClass: EmailTypeAttributes,
    BelongsToClasses: [
      {
        Klass: EmailTypeBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: EmailTypeHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: EmailTypeHasMany,
      },
    ],
  });

export const EmailTypeResourceClass = <TBase extends EmailTypeType>(BaseConstructor: TBase) =>
  class extends BaseConstructor implements EmailTypeMethods {};

export class EmailTypeResource extends ClassExtender<EmailTypeInterface>(
  BaseClass,
  EmailTypeResourceClass,
) {}

/**
 * Resource instance
 */
export const EmailType = APILibrary.createResource<EmailTypeResource>(EmailTypeResource);
